module.exports = __webpack_public_path__ + "static/media/rPrice.a5a3bb8e.png";